<aside [class.w-72]="isOpen" [class.w-20]="!isOpen" class="h-screen flex flex-col overflow-y-auto
       bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900
       text-white transition-all duration-300 ease-in-out">

  <!-- TOP -->
  <div class="flex items-center justify-between px-4 py-4">
    <div class="flex items-center gap-3 overflow-hidden">

      <i *ngIf="isOpen" class="fas fa-bus logo-icon flex-shrink-0"></i>

      <span class="logo-text whitespace-nowrap transition-all duration-300" [class.opacity-0]="!isOpen"
        [class.translate-x-[-10px]]="!isOpen">
        Busly
      </span>

    </div>

    <button (click)="toggleSidebar()" class="rounded-lg p-2 hover:bg-slate-700/50">
      <i class="fa-solid fa-bars"></i>
    </button>
  </div>

  <!-- SEARCH -->
  <div *ngIf="isOpen" class="px-3 pb-1">
    <div class="relative">
      <i class="fa-solid fa-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm"></i>
      <input type="text" [(ngModel)]="searchTerm" placeholder="Search menu..." class="w-full rounded-lg bg-slate-800/60 border border-slate-700 pl-9 pr-8 py-2 text-sm text-white
               placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-slate-500" />
      <button *ngIf="searchTerm" (click)="clearSearch()"
        class="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white">
        <i class="fa-solid fa-xmark text-sm"></i>
      </button>
    </div>
  </div>

  <!-- MENU -->
  <nav class="mt-2 flex flex-col gap-1 px-3">

    <div *ngFor="let group of filteredGroups; trackBy: trackByLabel">
      <button (click)="group.open = !group.open"
        class="flex w-full items-center gap-4 rounded-xl px-3 py-3 hover:bg-slate-700/50">

        <i class="{{ group.icon }} w-6 text-center"></i>
        <span class="flex-1 min-w-0 overflow-hidden whitespace-nowrap text-left" [class.opacity-0]="!isOpen">{{ group.label }}</span>

        <i *ngIf="isOpen" class="fa-solid fa-chevron-down transition-transform"
          [class.rotate-180]="group.open || isSearching"></i>
      </button>

      <!-- Submenu -->
      <div class="submenu ml-6 mt-1 flex flex-col gap-1 text-sm border-l border-slate-600/50 pl-4"
        [class.submenu-open]="(group.open || isSearching) && isOpen">

        <button *ngFor="let child of group.children; trackBy: trackByLabel" type="button" [routerLink]="child.link"
          routerLinkActive="bg-slate-700/40" (click)="clearSearch()"
          class="rounded-lg px-3 py-2 hover:bg-slate-700/40 text-left w-full">
          {{ child.label }}
        </button>
      </div>
    </div>

    <!-- No results -->
    <p *ngIf="isOpen && filteredGroups.length === 0" class="px-3 py-4 text-sm text-slate-400 text-center">
      No menu found
    </p>

  </nav>

  <!-- ================= SETTINGS ================= -->
  <div class="mt-auto px-3 pb-6">

    <button routerLink="/analytics" routerLinkActive="bg-slate-700/50" class="w-full flex items-center gap-4 rounded-xl px-3 py-3
         hover:bg-slate-700/50 text-white">

      <i class="fa-solid fa-gear w-6 text-center"></i>
      <span class="min-w-0 overflow-hidden whitespace-nowrap" [class.opacity-0]="!isOpen">Settings</span>
    </button>
  </div>
</aside>
